import { ComponentProps, ReactNode } from "react";
import { Alert, Button, Stack, Typography } from "@mui/material";
import { useTenantTranslation } from "hooks/formatters";
import { ConflictWarningBanner } from "./ConflictWarningBanner";
import { DefaultParameterStatus } from "./DefaultParameterStatus";
import { MaterialPropertiesLegend } from "./MaterialPropertiesLegend";

export const MaterialDefaultsEditorLayout = ({
  description,
  matchesScrapchefDefaults,
  revertButton,
  unavailableWarning,
  staleWarning,
  onDiscard,
  conflictWarning,
  children,
}: {
  description: string;
  matchesScrapchefDefaults: boolean | null;
  revertButton: ReactNode;
  unavailableWarning: string | null;
  staleWarning: string | null;
  onDiscard: () => void;
  conflictWarning: ComponentProps<typeof ConflictWarningBanner>;
  children: ReactNode;
}) => {
  const { t } = useTenantTranslation();
  return (
    <Stack gap={2} sx={{ flex: 1, minHeight: 0 }}>
      <Stack direction="row" gap={2} alignItems="center">
        <Typography color="text.secondary">{description}</Typography>
        <DefaultParameterStatus
          matchesScrapchefDefaults={matchesScrapchefDefaults}
        />
      </Stack>
      <Stack direction="row" gap={2} alignItems="center">
        <MaterialPropertiesLegend />
        {revertButton}
      </Stack>
      {unavailableWarning !== null ? (
        <Alert severity="warning">{unavailableWarning}</Alert>
      ) : null}
      {staleWarning !== null ? (
        <Alert
          severity="warning"
          action={
            <Button color="inherit" onClick={onDiscard}>
              {t("discardChanges")}
            </Button>
          }
        >
          {staleWarning}
        </Alert>
      ) : null}
      <ConflictWarningBanner {...conflictWarning} />
      {children}
    </Stack>
  );
};
